import { Request } from '@/utils';

const anTime = 150;
const apiUrl = '/crm/api/thirdparty/city/list/v1';

export default {
  props: {
    defaultProvince: {
      type: String,
    },
    defaultCity: {
      type: String,
    },
    level: {
      type: Number,
    },
  },
  data() {
    return {
      $allCity: [],
      $allDistrict: [],
      // 动画相关
      bodyWidth: document.body.offsetWidth || 375,
      cityAn: 'move',
      provinceAn: 'miniMove',
      districtAn: 'move',

      isShowProvince: true,
      isShowCity: false,
      isShowDistrict: false,

      provinceId: this.defaultProvince || '',
      provinceName: '',

      cityId: this.defaultCity || '',
      cityName: '',

      districtId: this.defaultDistrictId || '',
      districtName: '',

      provinceList: [],
      cityList: [],
      districtList: [],
    };
  },

  methods: {
    onCancel() {
      this.onClosePanel(4);
    },

    onClickTitle(type) {
      switch (type) {
        case 1: // 选择省份
          this.isShowCity = false;
          setTimeout(() => {
            this.isShowProvince = true;
          }, anTime);
          this.isShowDistrict = false;
          break;
        case 2: // 选择城市
          if (this.isShowProvince) {
            this.cityAn = 'move';
          }
          if (this.isShowDistrict) {
            this.cityAn = 'miniMove';
          }
          this.isShowProvince = false;
          setTimeout(() => {
            this.isShowCity = true;
          }, anTime);
          this.isShowDistrict = false;
          break;
        case 3: // 选择地区
          this.isShowProvince = false;
          this.isShowCity = false;
          setTimeout(() => {
            this.isShowDistrict = true;
          }, anTime);
          break;
        default:
          break;
      }
    },

    onClickPanel(type, item) {
      switch (type) {
        case 1: // 选择省份
          this.provinceName = item.name;
          this.provinceId = item.code;
          this.cityId = '';
          this.cityName = '';
          this.cityAn = 'move';
          this.fetchCity(this.provinceId, (data) => {
            this.cityList = data.map(el => (
              {
                code: el.regionCode,
                name: el.city,
              }
            ));
            this.setShowStatus();
            this.onClosePanel(type, item);
          });
          break;
        case 2: // 选择城市
          this.cityId = item.code;
          this.cityName = item.name;
          this.districtId = '';
          this.districtName = '';
          if (this.level > 2) {
            this.fetchDistrict(this.cityId, (data) => {
              this.districtList = data.map(el => (
                {
                  code: el.regionCode,
                  name: el.district,
                }
              ));
              this.setShowStatus();
              this.onClosePanel(type, item);
            });
          } else {
            this.setShowStatus();
            this.onClosePanel(type, item);
          }
          break;
        case 3: // 选择地区
          this.districtId = item.code;
          this.districtName = item.name;
          this.onClosePanel(type, item);
          break;
        default:
          break;
      }
    },

    onChoseCity(type, item) {
      const resData = {};
      this.cityId = item.code;
      this.cityName = item.name;
      resData.cityId = item.code;
      resData.cityName = item.name;
      this.setShowStatus();
      this.$emit('onCloseAddress', resData);
    },

    // 设置几个面板的显示状态
    setShowStatus(init) {
      if (this.showProvince()) {
        setTimeout(() => {
          this.isShowProvince = true;
        }, anTime);
      } else {
        this.isShowProvince = false;
      }
      if (this.showCity() && this.cityList.length > 0) {
        setTimeout(() => {
          this.isShowCity = true;
        }, anTime);
      } else {
        this.isShowCity = false;
      }
      if (this.showDistrict() && this.districtList.length > 0) {
        setTimeout(() => {
          this.isShowDistrict = true;
        }, anTime);
      } else {
        this.isShowDistrict = false;
      }
      if (init) {
        if (this.cityList.length === 0) {
          this.isShowCity = false;
          this.isShowProvince = true;
        }
      }
    },

    onClosePanel(type) {
      const resData = {
        type,
      };
      switch (type) {
        case 1: // 选择省份
          if (this.level === 1 || this.cityList.length === 0) {
            resData.provinceId = this.provinceId;
            resData.provinceName = this.provinceName;
            this.$emit('onCloseAddress', resData);
          }
          break;
        case 2: // 选择城市
          if (this.level === 2) {
            resData.provinceId = this.provinceId;
            resData.provinceName = this.provinceName;
            resData.cityId = this.cityId;
            resData.cityName = this.cityName;
            this.$emit('onCloseAddress', resData);
          }
          break;
        case 3: // 选择地区
          if (this.level === 3) {
            resData.provinceId = this.provinceId;
            resData.provinceName = this.provinceName;
            resData.cityId = this.cityId;
            resData.cityName = this.cityName;
            resData.districtId = this.districtId;
            resData.districtName = this.districtName;
            this.$emit('onCloseAddress', resData);
          }
          break;
        default:
          this.$emit('onCloseAddress', resData);
          break;
      }
    },

    initData(pram) {
      const prams = pram || {};
      this.provinceId = prams.provinceId || '';
      this.provinceName = prams.provinceName || '';
      this.cityId = prams.cityId || '';
      this.cityName = prams.cityName || '';
      this.districtId = prams.districtId || '';
      this.districtName = prams.districtName || '';
      if (this.provinceName) {
        this.fetchCity(this.provinceId, (data) => {
          this.cityList = data.map(el => (
            {
              code: el.regionCode,
              name: el.city,
            }
          ));
          this.setShowStatus(true);
        });
      } else {
        this.setShowStatus(true);
      }
    },

    initSelectData(params, callback) {
      Request.get(apiUrl,
        {
          ...params,
        },
      ).then((res) => {
        if (res.status !== 0) {
          this.clearData(params.level, res.msg || '获取城市失败');
          return false;
        }
        const data = res.data || [];
        callback(data);
        return true;
      }).catch(() => {
        this.clearData(params.level, '获取城市失败');
      });
    },

    clearData(level, msg) {
      this.$vux.toast.show({
        position: 'middle',
        type: 'text',
        text: msg,
        width: '16em',
      });
      if (level === 1) {
        this.provinceList = [];
        return;
      }

      if (level === 2) {
        this.cityList = [];
        return;
      }

      if (level === 3) {
        this.districtList = [];
      }
    },

    fetchProvice(callback) {
      this.initSelectData(
        {
          level: 1,
        },
        callback,
      );
    },

    fetchCity(province, callback) {
      this.initSelectData(
        {
          province,
          level: 2,
        },
        callback,
      );
    },

    fetchDistrict(city, callback) {
      this.initSelectData(
        {
          city,
          level: 3,
        },
        callback,
      );
    },

    showProvince() {
      if (this.provinceId && this.level > 1) {
        return false;
      }
      return true;
    },

    showCity() {
      if (this.cityId && this.level > 2) {
        return false;
      }
      if (this.cityId) {
        return true;
      }
      if (this.isShowProvince) {
        return false;
      }
      return true;
    },

    showDistrict() {
      if (this.isShowProvince || this.isShowCity) {
        return false;
      }

      if (this.cityId && this.level > 2) {
        return true;
      }
      return false;
    },
  },

  mounted() {
    this.fetchProvice((data) => {
      this.provinceList = data.map(item => (
        {
          code: item.regionCode,
          name: item.city,
        }
      ));
      this.initData();
    });
  },
};



// WEBPACK FOOTER //
// ./src/components/AddressSelect/main.js